/**
 * 
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import ServicePath from "@/core/ServicePath"
import { MainRequest } from "@/core/request";

export default class AddressRequest extends MainRequest {

    static update(data) {
        return this.postSEC(ServicePath.ADDRESS_UPDATE_PROFILE, data);
    }
}